module.exports = "<template>\r\n\t<require from=\"./duet-date-picker.css\"></require>\r\n</template>";